<template>
  <div>
    <b-row>
      <b-col sm="6">
        <p class="titleTable">รายการผลิตภัณฑ์ต้นแบบ</p>
      </b-col>
      <b-col sm="6">
        <b-button variant="success" class="btnForm1Detail"
          @click="gotoViewDetail('create')">
          สร้างใหม่
        </b-button>
      </b-col>
    </b-row>

    <v-client-table :name="name" :ref="name" :columns="columns" :options="options"
    :data="tableData">
      <div slot="beforeLimit" style="" class="right">
        <div style="margin-right: 10px;">
          <label :label-cols="2" :horizontal="true">หมวดหมู่:</label>
          <b-form-select @input="setSelectedCategory" :value="selectedCategory"
          :options="[...listCategoryFilter]">
          </b-form-select>
        </div>
      </div>
      <div slot="beforeLimit" style="" class="right">
        <div style="margin-right: 10px;">
          <label :label-cols="2" :horizontal="true">สถานะเผยแพร่:</label>
          <b-form-select @input="setSelectedPublic" :value="selectedPublic"
          :options="[...listPublicType]">
          </b-form-select>
        </div>
      </div>
      <div slot="create_at" slot-scope="props" target="_blank" style="text-align:center;">
        {{formateDate(props.row.create_at)}}
      </div>
      <div slot="update_at" slot-scope="props" target="_blank" style="text-align:center;">
        {{formateDate(props.row.update_at)}}
      </div>
      <div slot="id" slot-scope="props" target="_blank" style="text-align:center;">
        <a href="#" @click="gotoViewDetail(props.row.id)" style="text-decoration: none;">Details</a>
      </div>
    </v-client-table>
  </div>
</template>

<script>
import moment from 'moment';
import {
  mapGetters,
  mapActions,
} from 'vuex';

export default {
  watch: {
    selectedPublic() {
      this.setMyFilter();
    },
    selectedCategory() {
      this.setMyFilter();
    },
  },
  async created() {
    await this.$store.dispatch('Product/clearState');
    await this.$store.dispatch('Product/getData');
  },
  computed: {
    ...mapGetters('Product', ['listProduct', 'selectedPublic', 'listPublicType', 'selectedCategory',
      'listCategoryFilter']),
  },
  methods: {
    ...mapActions('Product', ['setSelectedPublic', 'setSelectedCategory']),
    setMyFilter() {
      const {
        selectedPublic,
        selectedCategory,
      } = this;
      const valueFilter = {
        selectedPublic,
        selectedCategory,
      };
      this.$store.commit('Product/SET_CUSTOM_FILTER', {
        filter: 'smartFilter',
        value: valueFilter,
      });
    },
    formateDate(date) {
      return date ? moment(date).format('DD/MM/yyyy, h:mm:ss a') : '-';
    },
    gotoViewDetail(id) {
      this.$router.push(`detail/${id}`);
    },
  },
  data() {
    return {
      columns: [
        'name',
        'category_id',
        'area_id',
        'heritage_id',
        'public',
        'view',
        'create_at',
        'update_at',
        'id',
      ],
      tableData: [],
      name: 'Product',
      options: {
        texts: {
          filterPlaceholder: 'Search',
        },
        preserveState: true,
        headings: {
          name: 'ชื่อผลิตภัณฑ์ต้นแบบ',
          category_id: 'หมวดหมู่ผลิตภัณฑ์ต้นแบบ',
          area_id: 'พื้นที่ตั้ง',
          heritage_id: 'ชื่อมรดกภูมิปัญญาทางวัฒนธรรม',
          public: 'สถานะ',
          view: 'ยอดการเข้าชม',
          create_at: 'เวลาที่สร้าง',
          update_at: 'เวลาที่อัปเดตล่าสุด',
          id: 'รายละเอียด',
        },
        customFilters: [{
          name: 'smartFilter',
          callback(row, query) {
            const {
              selectedPublic,
              selectedCategory,
            } = query;
            let statusMatch = true;
            if (selectedPublic !== 'All') {
              console.log(row.public);
              statusMatch = row.public === selectedPublic;
            }

            let statusCat = true;
            if (selectedCategory !== 'All') {
              statusCat = row.category_id === selectedCategory;
            }
            return statusMatch && statusCat;
          },
        }],
        sortIcon: {
          is: 'fa-sort',
          base: 'fa',
          up: 'fa-sort-up',
          down: 'fa-sort-down',
        },
      },
    };
  },
};
</script>

<style scoped>
  .titleTable {
    padding-left: 20px;
    font-size: 20px;
    margin-bottom: 0;
    color: #173B6B;
  }

  .custom-select {
    border-radius: 20px;
  }

  .btnForm1Detail {
    float: right;
    margin: 0 20px 20px 0;
  }
</style>
